<script setup>
  defineProps({
    size: {
      type: [Number, String],
      default: 50,
    },
    color: {
      type: String,
      default: '#3498db',
    },
    thickness: {
      type: [Number, String],
      default: 3,
    },
  })
</script>

<template>
  <div class="custom-spinner-container" :style="{ height: `${size}px`, minHeight: `${size}px` }">
    <div
      class="custom-spinner"
      :style="{
        width: `${size}px`,
        height: `${size}px`,
        borderWidth: `${thickness}px`,
        borderTopColor: color,
      }"
    ></div>
  </div>
</template>

<style scoped>
  .custom-spinner-container {
    display: inline-flex;
    margin-top: 5px;
  }

  .custom-spinner {
    position: relative;
    border-radius: 50%;
    border-style: solid;
    border-color: rgba(0, 0, 0, 0.1);
    animation: spin 0.8s linear infinite;
  }

  .custom-spinner::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 30%;
    height: 30%;
    background-color: inherit;
    border-radius: 50%;
    transform: translate(-50%, -50%);
    opacity: 0.2;
    animation: pulse 1.5s ease-in-out infinite;
  }

  .custom-spinner::after {
    content: '';
    position: absolute;
    top: -10%;
    left: -10%;
    right: -10%;
    bottom: -10%;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 50%;
    animation: spin 1.2s linear infinite reverse;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes pulse {
    0%,
    100% {
      transform: translate(-50%, -50%) scale(1);
      opacity: 0.2;
    }
    50% {
      transform: translate(-50%, -50%) scale(1.3);
      opacity: 0.5;
    }
  }
</style>
